var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getPoint)?_c('div',[_c('invite-home-header',{attrs:{"page-name":"招待","istop":true}}),_vm._v(" "),_c('invite-home-point'),_vm._v(" "),_c('invite-home-list')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }